(() => {
  const STORE_KEY = 'spot-tap-streak-best';
  const HIT_WINDOW = 260; // ms um den Beat herum
  const BEAT_MS = 900;    // Laufzeit des Rings von aussen nach innen

  const init = (card) => {
    if (card.dataset.gameReady === 'true') return;
    card.dataset.gameReady = 'true';

    const section = card.closest('.spot-game');
    const puck = card.querySelector('[data-game-puck]');
    const startBtn = card.querySelector('[data-game-start]');
    const msg = card.querySelector('[data-game-msg]');
    const streakEl = card.querySelector('[data-game-streak]');
    const bestEl = card.querySelector('[data-game-best]');
    const beat = card.querySelector('[data-game-beat]');
    if (!section || !puck || !startBtn) return;

    const d = card.dataset;
    let running = false;
    let streak = 0;
    let best = 0;
    let beatAt = 0;     // Zeitpunkt, an dem der Ring den Puck erreicht
    let timer = null;
    let missTimer = null;
    let flashTimer = null;
    let newRecord = false;

    try { best = parseInt(localStorage.getItem(STORE_KEY) || '0', 10) || 0; } catch (e) {}
    bestEl.textContent = String(best);

    const setMsg = (t) => { if (msg) msg.textContent = t; };
    const flash = (cls) => {
      section.classList.remove('is-hit', 'is-miss');
      void section.offsetWidth;
      section.classList.add(cls);
      window.clearTimeout(flashTimer);
      flashTimer = window.setTimeout(() => section.classList.remove(cls), 420);
    };

    const rand = (min, max) => min + Math.random() * (max - min);

    const scheduleBeat = () => {
      if (!running) return;
      // Pausen werden mit steigender Serie kuerzer
      const gapMin = Math.max(350, 1100 - streak * 45);
      const gapMax = Math.max(700, 2200 - streak * 80);
      const gap = rand(gapMin, gapMax);
      timer = window.setTimeout(() => {
        if (!running) return;
        section.classList.remove('is-beating');
        void beat.offsetWidth;
        section.style.setProperty('--spot-beat-ms', `${BEAT_MS}ms`);
        section.classList.add('is-beating');
        beatAt = performance.now() + BEAT_MS;
        // Wer nach dem Fenster nicht getippt hat, hat verpasst
        missTimer = window.setTimeout(() => {
          if (!running) return;
          gameOver(d.msgLate);
        }, BEAT_MS + HIT_WINDOW);
      }, gap);
    };

    const gameOver = (reason) => {
      running = false;
      window.clearTimeout(timer);
      window.clearTimeout(missTimer);
      section.classList.remove('is-beating');
      flash('is-miss');
      const over = (d.msgOver || '').replace('{n}', String(streak));
      setMsg(newRecord && streak > 0 ? (d.msgRecord || '').replace('{n}', String(streak)) : `${reason} ${over}`.trim());
      startBtn.textContent = d.labelAgain || d.labelStart || 'Start';
      startBtn.hidden = false;
    };

    const start = () => {
      running = true;
      streak = 0;
      newRecord = false;
      streakEl.textContent = '0';
      setMsg(d.msgReady || '');
      startBtn.hidden = true;
      section.classList.remove('is-hit', 'is-miss', 'is-beating');
      scheduleBeat();
    };

    const onTap = () => {
      puck.classList.add('is-pressed');
      window.setTimeout(() => puck.classList.remove('is-pressed'), 140);
      if (!running) return;

      const delta = performance.now() - beatAt;
      if (!beatAt || delta < -HIT_WINDOW) {
        gameOver(d.msgEarly);
        return;
      }
      if (delta > HIT_WINDOW) {
        gameOver(d.msgLate);
        return;
      }

      // Treffer
      window.clearTimeout(missTimer);
      section.classList.remove('is-beating');
      beatAt = 0;
      streak += 1;
      streakEl.textContent = String(streak);
      if (streak > best) {
        best = streak;
        newRecord = true;
        bestEl.textContent = String(best);
        try { localStorage.setItem(STORE_KEY, String(best)); } catch (e) {}
      }
      flash('is-hit');
      setMsg((d.msgHit || '').replace('{ms}', String(Math.abs(Math.round(delta)))));
      scheduleBeat();
    };

    startBtn.addEventListener('click', start);
    puck.addEventListener('pointerdown', (e) => { e.preventDefault(); onTap(); });
    puck.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); onTap(); }
    });

    // Spiel stoppen, wenn die Sektion aus dem Bild scrollt
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (!en.isIntersecting && running) gameOver(''); });
      }, { threshold: 0.1 }).observe(card);
    }
  };

  const boot = () => document.querySelectorAll('[data-spot-game]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
